<div class="summary-operation-container">
  <div class="summary-operation-title">
    Resumen de la operación
  </div>
  <div class="summary-operation-detail mt-4">
    <div class="amount p-2">
      <p class="subtitle">{{"Importe a pagar" | translate}}</p>
      <p class="value">{{summaryPayment.amount}}</p>
    </div>

    <div class="receiver layout p-2">
      <p class="subtitle ">{{"Destinatario" | translate}}</p>
      <p class="value">{{summaryPayment.receiver}}</p>
    </div>

    <div class="bank p-2">
      <p class="subtitle">{{"Banco" | translate}}</p>
      <p class="value">{{summaryPayment.bank}}</p>
    </div>

    <div class="concept layout p-2">
      <p class="subtitle" >{{"Concepto" | translate}}</p>
      <p class="value">{{summaryPayment.account}}</p>
    </div>

    <div class="commissions p-2">
      {{"Esta operación genera una comisión de" | translate}} {{summaryPayment.commission}}
    </div>
  </div>

  <div class="btns-container mt-5">
    <button class="btn-secondary back-btn btn" (click)="closeModal()">{{"Regresar" | translate}}</button>
    <button class="btn-primary btn" [disabled]="!checkingData" (click)="openAuthSystem()">{{"Realizar pago" | translate}}</button>
  </div>
</div>